import { TaskMonthRecurrency } from "./TaskMonthRecurrency";
import { TaskOneTimeRecurrency } from "./TaskOneTimeRecurrency";
import { TaskRecurrencyType } from "./TaskRecurrencyType";
import { TaskShiftRecurrency } from "./TaskShiftRecurrency";

export class TaskRecurrency {
    public id: number;
    public type: TaskRecurrencyType = TaskRecurrencyType.noRecurrency;
    public createdAt: Date;
    public lastUpdatedAt: Date;
    public isActive: boolean;
    public fromDate?: Date;
    public untilDate?: Date;
    // Only once
    public taskOneTimeRecurrencies: TaskOneTimeRecurrency[] = [];
    public executionDate?: Date;
    // Certian shifts
    public taskShiftRecurrencies: TaskShiftRecurrency[] = [];
    // Weekly/Daily
    public week: number = 1;
    public weekday0: boolean;
    public weekday1: boolean;
    public weekday2: boolean;
    public weekday3: boolean;
    public weekday4: boolean;
    public weekday5: boolean;
    public weekday6: boolean;
    // Monthly
    public monthRecurrency: TaskMonthRecurrency = TaskMonthRecurrency.DayOfMonth;
    public month: number = 1;
    // Monthly - Specific Date
    public day: number = 1;
    // Monthly - Specific Week
    public weekday?: number;
    public weekdayNumber?: number;
}


// WEBPACK FOOTER //
// ./src/Models/Tasks/TaskRecurrencies/TaskRecurrency.ts